import { FC } from "react";
import classNames from "classnames";
import { MdCheck, MdPriorityHigh } from "react-icons/md";
import type { PassengerTabItem } from "../PassengerTabs";

type PassengerStatusBadgeProps = {
  item: PassengerTabItem;
  index: number;
  isActive: boolean;
  className?: string;
};

const PassengerStatusBadge: FC<PassengerStatusBadgeProps> = ({ item, index, isActive, className }) => {
  return (
    <span
      className={classNames(
        "flex h-8 w-8 shrink-0 items-center justify-center rounded-full text-sm font-semibold transition-colors",
        item.hasError
          ? "bg-background-danger text-font-danger"
          : item.isComplete
            ? "bg-font-success/15 text-font-success"
            : isActive
              ? "bg-background-primary text-font-inverted"
              : "bg-background-minimal text-font-subtle",
        className,
      )}
    >
      {item.hasError ? <MdPriorityHigh className="h-4 w-4" /> : item.isComplete ? <MdCheck className="h-4 w-4" /> : index + 1}
    </span>
  );
};

export default PassengerStatusBadge;
